import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { Http, Headers, Request, Response, RequestOptions } from '@angular/http';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs/Rx';

import { Constants } from '../../shared/models/constants';
import { InboxPouchService } from '../inbox/inbox.pouchdb.service';
import { ShelfPouchDb } from '../shelf.pouchdb.service';
import { AllComponent } from '../all/all.component';
import { Component_interactionService } from '../../component_interaction.service';
import { IS_ElectronService } from '../../shared/IS_Electron.service';
declare var gapi: any;
declare var google: any;

@Component({
    selector: 'app-inboxdetails',
    templateUrl: './inboxDetails.component.html',
    styleUrls: ['./inboxDetails.component.css']
})
export class InboxDetailsComponent implements OnInit {
    @Input() data: any;
    public inboxData: any;
    public inboxViewType = 'grid';
    ShareList = [];
    showInboxData = false;
    inboxChangeData: any;
    filterdName;
    googlechilderen;
    Readjson;
    downloadNextBookInAllDownload: any;
    public downloadAllExportsCount: any;
    public isAllDownloadChecked = false;
    public exportBookSubscription: any;

    marchedInboxIdsArr: any;
    inboxUpdateSubscribe: any;

    exampleData: any
    @ViewChild(AllComponent)
    private AllComponentScope: AllComponent;

    constructor(public ele: ElementRef, public cdr: ChangeDetectorRef, public http: Http, private inboxPouchService: InboxPouchService, private shelfpouch: ShelfPouchDb, private componentInteraction: Component_interactionService, private ElectronService: IS_ElectronService) { }

    ngOnInit() {
        document['inbox'] = this;
        var self = this;
        this.downloadAllExportsCount = 0;

        if (this.data.inboxData) {
            if (this.data.inboxData.data.bids) {
                this.inboxData = this.data.inboxData.data.bids;
                this.inboxChangeData = _.cloneDeep(this.data.inboxData.data.bids);
                self.GetContactList()
            }

            else {
                this.inboxData = [];
                this.inboxChangeData = [];
            }

            // this.cdr.detectChanges()

        }
        this.downloadNextBookInAllDownload = this.inboxPouchService.downloadNextBookInAllDownload$.subscribe(data => {

            // self.isBookDownloading = false;

            self.ele.nativeElement.querySelectorAll('.loader')[0].classList.remove('showLoader');

            self.cdr.detectChanges();
            if (self.isAllDownloadChecked) {

                if (self.downloadAllExportsCount > 0) {


                    if (self.downloadAllExportsCount != self.inboxChangeData.length) {

                        self.inboxChangeData[self.downloadAllExportsCount].isDownloaded = 1;
                        self.downloadAllExports(self.inboxChangeData[self.downloadAllExportsCount])
                    }


                }

                else {

                    self.inboxChangeData[0].isDownloaded = 1;
                }

            }

            else {
                if (self.clickedDownloadData) {
                    var ind = _.findIndex(self.inboxChangeData, function (data) {

                        self.exampleData = data;
                        return self.exampleData._id == self.clickedDownloadData._id;
                    })

                    self.inboxChangeData[ind].isDownloaded = 1;
                }



            }
            self.cdr.detectChanges();

        })

    }


    ngOnDestroy() {
        if (this.downloadNextBookInAllDownload) this.downloadNextBookInAllDownload.unsubscribe();
        if (this.exportBookSubscription) this.exportBookSubscription.unsubscribe();

        this.cdr.detach()
    }


    selectExportToDownload(data, i) {


        if (data.checkedForDownload == true)
            data.checkedForDownload = false;

        else data.checkedForDownload = true
    }


    checkisAllDownloadChecked() {

        this.isAllDownloadChecked = !this.isAllDownloadChecked;
        var self = this;
        _.forEach(this.inboxChangeData, function (data) {

            if (self.isAllDownloadChecked == true)
                data.checkedForDownload = true;
            else data.checkedForDownload = false;
        })
    }

    public clonedDownloadData = [];
    gotodownloadAllExports() {

        this.downloadAllExports(this.inboxChangeData[0]);
    }

    downloadAllExports(data) {

        var self = this;



        if (this.isAllDownloadChecked == true)

            self.downloadIndividalExportedData(data);

        else return

    }

    public isBookDownloading = false;
    downloadIndividalExportedData(data) {
        var filename;
        var self = this;

        // data.isDownloading = true;
        // this.isBookDownloading = true;

        this.ele.nativeElement.querySelectorAll('.loader')[0].classList.add('showLoader');

        if (self.downloadAllExportsCount == 0) {
            self.inboxChangeData[0].isDownloaded = 1;

        }

        self.downloadAllExportsCount++;

        self.getAndupdateDataToDrive(data, filename);


    }

    clickedDownloadData: any

    downloadExportedData(data) {
        var filename;
        var self = this;
        // this.isBookDownloading = true;


        this.ele.nativeElement.querySelectorAll('.loader')[0].classList.add('showLoader');


        // data.isDownloading = true;
        this.clickedDownloadData = data;
        self.getAndupdateDataToDrive(data, filename);
        // data.isDownloaded = 1;
    }


    getAndupdateDataToDrive(data, filename) {
        var self = this;
        this.retrieveAllFilesInFolder(data.contentURL, filename, data);

        this.inboxPouchService.finInboxBids().then(function (result) {

            result[data.book._id]['bids'][data._id].isDownloaded = 1;

            self.inboxPouchService.pushInboxIdsDoc(result);

        }).catch(function (err) {

        })
    }


    retrieveAllFilesInFolder(folderId, filename, data) {
        var retrievePageOfChildren = function (request, result, that) {
            request.execute(function (resp) {
                result = result.concat(resp.items);

                that.googlechilderen = result;

                console.log('googlechildren' + result)
                var nextPageToken = resp.nextPageToken;
                if (nextPageToken) {
                    request = gapi.client.drive.files.list({
                        'pageToken': nextPageToken
                    });
                    retrievePageOfChildren(request, result, this);
                } else {
                    that.copyfiletomedia(that.googlechilderen, data)
                }
            });
        }
        var initialRequest = gapi.client.drive.files.list({
            q: "'" + folderId + "' in parents",
            'maxResults': 1000,
        });

        retrievePageOfChildren(initialRequest, [], this);


    }
    copyfiletomedia(files, data) {
        var readson;
        if (files) {
            console.log(files)
            var getaldata = _.filter(files, function (o) {
                // 

                console.log(o);
                return o.mimeType != "application/json";
            });
            readson = _.filter(files, function (o) { return o.mimeType == "application/json"; });
            let that = this
            if (this.ElectronService.IS_ELECTRON) {
                if (getaldata.length > 0) this.ElectronService.downloadExportFile(getaldata[0].webContentLink);
            }
            else {
                getaldata.forEach(element => {
                    var body = {
                        'title': element.title, 'parents': [{ 'id': localStorage.currentDriveMediaId }]
                    };
                    var request = gapi.client.drive.files.copy({
                        'fileId': element.id,
                        'resource': body
                    });
                    request.execute(function (resp) {
                        console.log(resp);


                    });

                })

            }

            this.Readfile(readson, data)
        }



    }
    Readfile(readson, data) {
        let that = this;
        var contentFile;
        var senderUserId = data.from;
        var request = gapi.client.drive.files.get({
            fileId: readson[0].id,
            alt: 'media'
        })
        request.execute(function (resp) {
            that.Readjson = resp;
            contentFile = resp[0];
            if (that.ElectronService.IS_ELECTRON) {
                that.changeMediaUrls(contentFile, senderUserId);
                if (data.book.bookCategory == 0) {
                    data = that.changeBookPathUrls(data, senderUserId);

                    that.exportBookSubscription = that.ElectronService.isExportBook$.subscribe(message => {
                        if (message)
                            that.inboxPouchService.addContentToBook(contentFile, data);
                    });
                    var Book_Path = that.ElectronService.USER_PATH + '/' + data.book.bId;
                    if (!that.ElectronService.FS.existsSync(Book_Path)) { //Download Book Is not there  
                        that.ElectronService.exportBookDownload(data.book);
                    }
                    else {
                        that.inboxPouchService.addContentToBook(contentFile, data);
                    }

                }
                else {
                    that.inboxPouchService.addContentToBook(contentFile, data);
                }
            }
            else {
                that.inboxPouchService.addContentToBook(contentFile, data);
            }


        })
    }
    changeBookPathUrls(data, senderUserId) {
        var userData = JSON.parse(localStorage.nasResponse);
        var currentUserId = userData.signIn.organizationId + '_' + userData.signIn.user.id;
        data.book.url = data.book.url.replace(senderUserId, currentUserId);
        data.book.coverPage = data.book.coverPage.replace(senderUserId, currentUserId);
        return data;
    }

    changeMediaUrls(contentFile, senderUserId) {
        var userData = JSON.parse(localStorage.nasResponse);
        var currentUserId = userData.signIn.organizationId + '_' + userData.signIn.user.id;
        for (var i = 0; i < contentFile.content.length; i++) {
            if (contentFile.content[i].pageContent && contentFile.content[i].pageContent.pageAssets) {
                if (contentFile.content[i].pageContent.pageAssets.length > 0) {
                    for (var j = 0; j < contentFile.content[i].pageContent.pageAssets.length; j++) {
                        contentFile.content[i].pageContent.pageAssets[j] = contentFile.content[i].pageContent.pageAssets[j].replace(senderUserId, currentUserId);
                    }
                    contentFile.content[i].pageContent.pageChildren = _.replace(contentFile.content[i].pageContent.pageChildren, new RegExp(senderUserId, "g"), currentUserId);
                }
            }
        }

    }


    openExportedBook(book) {

        var self = this;

        // this.inboxPouchService.openExportedBook(book).then(function (result) {

        //     self.componentInteraction.selectedBookData(result);

        // }).catch(function (err) {


        // });
    }



    GetContactList() {
        this.ShareList = JSON.parse(localStorage.contacts);
        var self = this;
        for (var i = 0; i < this.inboxData.length; i++) {

            var d = new Date(this.inboxData[i].time * 1000);

            this.inboxChangeData[i].time = d;

            // this.inboxData[i].time = d.getDate() + '/' + (d.getMonth()+1) + '/' + d.getFullYear()

            // for today date

            var inboxDate = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();

            var todayDate = new Date();

            var todayDateInFormat = todayDate.getDate() + '/' + (todayDate.getMonth() + 1) + '/' + todayDate.getFullYear();

            var yesterDayDate = new Date(Date.now() - 864e5)

            var yesterDayDateInFormat = yesterDayDate.getDate() + '/' + (yesterDayDate.getMonth() + 1) + '/' + yesterDayDate.getFullYear();

            if (todayDateInFormat == inboxDate) {

                var hours = d.getHours().toString();
                var minutes = d.getMinutes().toString();
                if (minutes.length == 1) {

                    minutes = '0' + minutes;
                }
                this.inboxChangeData[i].time = hours + ':' + minutes;
            }

            else if (yesterDayDateInFormat == inboxDate) {
                this.inboxChangeData[i].time = 'Yesterday'

            }

            else {
                this.inboxChangeData[i].time = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear()

            }

            this.showInboxData = true;

        }

        this.inboxChangeData = this.inboxChangeData.reverse();
    }
}





// WEBPACK FOOTER //
// ./src/app/shelf/inboxDetails/inboxDetails.component.ts